export default __webpack_public_path__ + "static/media/Contact-us.20c6a7ed.jpg";